import { render, staticRenderFns } from "./ComprasTransito.vue?vue&type=template&id=78cb9a8a"
import script from "./ComprasTransito.vue?vue&type=script&lang=js"
export * from "./ComprasTransito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports